define.alias("checkout/components/seamless-checkout-table", "calendar/components/seamless-checkout-table");